import React from 'react';
import { ontologyRadialTickTowardHub } from './ontologyMiniQuadrantMarks';
import { ontologyRimPoint, ontologySectorPathAnnular } from './ontologyMarkGeometry';

/**
 * Shared SVG pieces for the Ontology mark (hero + entity icon).
 * Flat monoline treatment, calm geometry — contemporary instrument / systems read.
 *
 * @param {{ bgGradientId?: string }} [_props] - kept for call sites; mark is flat / no defs.
 */
export function OntologyDiagramDefs(_props) {
  return null;
}

const ONTOLOGY_PANEL_FILL = '#2d241c';
/** Cool-neutral monoline (flat UI, no metallic gradient). */
const LINE = '#d4d0ca';

function OntologySectorMark() {
  const cx = 100;
  const cy = 100;
  const holeR = 16;
  const outerR = 58;
  const halfAngle = 24;
  const indent = 0.14;
  const sectorStroke = 0.72;
  const plusRadius = 51;
  const tickLen = 12.5;
  const tickStroke = 0.95;
  const sectorCenters = [270, 0, 90, 180];
  const plusAngles = [315, 45, 135, 225];

  return (
    <g aria-hidden="true">
      {sectorCenters.map((deg) => (
        <path
          key={`sector-${deg}`}
          d={ontologySectorPathAnnular(cx, cy, holeR, outerR, deg, halfAngle, indent)}
          fill={ONTOLOGY_PANEL_FILL}
          stroke={LINE}
          strokeWidth={sectorStroke}
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      ))}

      {plusAngles.map((deg) => {
        const point = ontologyRimPoint(cx, cy, plusRadius, deg);
        const t = ontologyRadialTickTowardHub(cx, cy, point.x, point.y, tickLen);
        return (
          <line
            key={`tick-${deg}`}
            x1={t.x1}
            y1={t.y1}
            x2={t.x2}
            y2={t.y2}
            stroke={LINE}
            strokeWidth={tickStroke}
            strokeLinecap="round"
          />
        );
      })}
    </g>
  );
}

/** @param {{ bgGradientId?: string }} [_props] - kept for call sites. */
export function OntologyDiagramBody(_props) {
  return <OntologySectorMark />;
}
